<template>
  <div class="component-wrapper container d-flex flex-column align-center mt-8">
    <Breadcrumb class="breadcrumb" :breadcrumbItems="breadCrumbItems" />
    <div class="d-flex mt-2 container">
      <div
        class="
          d-flex
          flex-column
          text-sm-body-1
          font-weight-regular
          mb-sm-16 mb-8
          container
          align-self-start
        "
      >
        <div v-if="currentReport.submissionStatus == 'acceptedByESMA'">
          Κατάσταση: Αποδεκτή από ESMA
        </div>

        <div v-else-if="currentReport.submissionStatus == 'pending'">
          Κατάσταση: Δεν έχει υποβληθεί στην Ε.Κ.
        </div>

        <div v-else-if="currentReport.submissionStatus == 'submittedToESMA'">
          Κατάσταση: Έχει υποβληθεί στην ESMA
        </div>

        <div v-else-if="currentReport.submissionStatus == 'submittedToHCMC'">
          Κατάσταση: Εκκρεμεί απάντηση από την ESMA
        </div>

        <div v-else-if="currentReport.submissionStatus == 'returnedByHCMC'">
          Κατάσταση: Απαιτούνται διορθώσεις πριν την υποβολή στην ESMA
          <v-icon color="error" class="mb-1"> mdi-alert </v-icon>
        </div>
        <div
          v-if="
            currentReport.submissionStatus == 'returnedByESMA' ||
              currentReport.submissionStatus == 'returnedByHCMC'
          "
        >
          Σχόλια Ε.Κ.: {{ currentReport.lastValidationMessage }}
        </div>
      </div>
      <v-btn
        v-if="currentReport.submissionStatus == 'pending'"
        class="
          success
          rounded
          text-sm-body-1
          font-weight-regular
          button
          ml-auto
          d-sm-block d-none
        "
        @click="onSubmit"
        :loading="loader"
        >Υποβολή στην Ε.Κ.</v-btn
      >
    </div>

    <div
      class="
        d-flex
        flex-sm-row flex-column
        mb-sm-4 mb-2
        justify-md-space-between justify-center
        align-center
        container
      "
    >
      <v-btn
        v-if="currentReport.submissionStatus == 'pending'"
        class="
          mb-2
          success
          rounded
          text-sm-body-1
          font-weight-regular
          button
          d-sm-none d-block
        "
        @click="onSubmit"
        :loading="loader"
        >Υποβολή στην Ε.Κ.</v-btn
      >

      <v-btn
        class="
          mr-md-0 mr-sm-4
          mb-sm-0 mb-2
          primary
          rounded
          text-sm-body-1
          font-weight-regular
          button
        "
        @click="onSave"
        >Λήψη αρχείου</v-btn
      >

      <v-btn
        class="primary rounded text-sm-body-1 font-weight-regular button"
        @click="onShow"
        >Προβολή αρχείου</v-btn
      >
      <v-btn
        v-if="currentReport.submissionStatus != 'pending'"
        class="
          primary
          rounded
          text-sm-body-1
          font-weight-regular
          button
          d-none d-md-flex
        "
        :to="`/employees/report/${currentReport.reportId}/history`"
        >Ιστορικό ενεργειών</v-btn
      >
      <v-btn
        v-else
        class="
          primary
          rounded
          text-sm-body-1
          font-weight-regular
          button
          d-none d-md-flex
        "
        >Ανέβασμα νέου αρχείου</v-btn
      >
    </div>

    <div
      class="
        d-md-block d-flex
        flex-sm-row flex-column
        mb-sm-16 mb-8
        justify-center
        align-center
      "
    >
      <v-btn
        :to="`/employees/report/${currentReport.reportId}/history`"
        v-if="currentReport.submissionStatus != 'pending'"
        class="
          mr-md-0 mr-sm-4
          mb-sm-0 mb-2
          primary
          rounded
          text-sm-body-1
          font-weight-regular
          button
          d-md-none d-flex
        "
        >Ιστορικό ενεργειών</v-btn
      >
      <v-btn
        v-else
        class="
          primary
          rounded
          text-sm-body-1
          font-weight-regular
          button
          d-md-none d-flex
        "
        >Ανέβασμα νέου αρχείου</v-btn
      >
      <v-btn
        v-if="
          currentReport.submissionStatus == 'returnedByHCMC' ||
            currentReport.submissionStatus == 'returnedByESMA'
        "
        :to="`/employees/report/${currentReport.reportId}/update_report`"
        class="primary rounded text-sm-body-1 font-weight-regular button"
        >Υποβολή νέας έκδοσης
      </v-btn>

      <v-btn
        class="primary rounded text-sm-body-1 font-weight-regular button"
        @click="onSave"
        >Λήψη αρχείου αποδοχής</v-btn
      >
    </div>

    <div class="align-self-center">
      <v-btn
        to="/employees"
        class="secondary rounded text-sm-body-1 font-weight-regular"
        >Επιστροφή</v-btn
      >
    </div>

    <v-dialog min-width="auto" v-model="dialog">
      <ShowReport v-if="dialog" />
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import ShowReport from "../../components/Modals/ShowReport.vue";
import Breadcrumb from "../../components/Breadcrumb.vue";

export default {
  components: {
    ShowReport,
    Breadcrumb,
  },
  created() {
    // console.log(this.currentReport);
    this.breadCrumbItems[1] = {
      text: `${new Date(
        this.currentReport.lastUploadedVersionDate
      ).toLocaleDateString("el")}`,
      disabled: true,
      to: `/employees/report/${this.currentReport.reportId}/details`,
    };
  },

  data() {
    return {
      loader: false,
      breadCrumbItems: [
        {
          text: "Αρχική",
          disabled: false,
          to: "/employees",
        },
      ],

      downloadMenu: [
        {
          text: "Λήψη σε μορφή excel, csv",
          icon: "mdi-file-excel",
          color: "success",
          action: "downloadExcel",
        },
        {
          text: "Λήψη σε μορφή pdf",
          icon: "mdi-file-pdf-box",
          color: "error",
          action: "downloadPdf",
        },

        {
          text: "Λήψη σε μορφή zip",
          icon: "mdi-folder-zip",
          color: "primary",
          action: "downloadZip",
        },
      ],
    };
  },

  computed: {
    ...mapState({
      savedReport: (state) => state.reports.savedReport,
      currentReport: (state) => state.reports.currentReport,
    }),

    dialog: {
      get() {
        return this.$store.state.dialogs.showReportDialog;
      },
      set(value) {
        return this.updateShowReportDialog(value);
      },
    },
  },

  methods: {
    ...mapMutations(["updateShowReportDialog"]),
    ...mapActions(["getSavedReport", "submitReport"]),

    async onSubmit() {
      try {
        this.loader = true;
        await this.submitReport(this.currentReport.lastUploadedVersionId);
        this.loader = false;
        this.$router.push("/employees");
      } catch {
        this.loader = false;
      }
    },

    async onSave() {
      try {
        await this.getSavedReport(this.currentReport.lastUploadedVersionId);

        const filename = this.savedReport.headers["content-disposition"]
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim();

        const url = window.URL.createObjectURL(
          new Blob([this.savedReport.data])
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } catch {}
    },

    onShow() {
      this.updateShowReportDialog(true);
    },
  },
};
</script>

<style scoped lang="scss">
.container,
.breadcrumb {
  width: 950px !important;
}

.button {
  width: 300px;
}

@media only screen and (max-width: 960px) {
  .container,
  .breadcrumb {
    width: 100% !important;
  }
}
</style>
